import 'isomorphic-fetch';
import { Carlines } from '../typings/general';

interface FetchCarlinesOptions {
  readonly faServicesUrl: string;
  readonly apiKey: string;
  readonly modelYear: string;
  readonly serviceConfigsServiceConfig?: string;
}

function createCarlinesUrl(params: URLSearchParams, urlOrigin: string): string {
  return `${urlOrigin}/maintenance/carlines?${params.toString()}`;
}

export async function fetchCarlines({
  faServicesUrl,
  apiKey,
  modelYear,
}: FetchCarlinesOptions): Promise<Carlines> {
  const params = new URLSearchParams();
  params.set('brand', 'V');
  params.set('importerCode', '444');
  params.set('languageCode', 'en-US');
  params.set('modelYear', modelYear);

  const response = await fetch(createCarlinesUrl(params, faServicesUrl), {
    headers: { 'x-api-key': apiKey },
  });

  const carlines = await response.json();

  if (response.status >= 400) throw new Error(carlines.message);

  return carlines;
}
